<template lang="pug">
  sui-grid
    sui-grid-row
      sui-grid-column
        sui-dropdown(
          multiple,
          fluid,
          placeholder="Select players...",
          selection,
          :options="options",
          v-model="selected")

    sui-grid-row
      sui-grid-column
        sui-table(
          :columns="selected.length + 1",
          unstackable,
          single-line)
          sui-table-header
            sui-table-row
              sui-table-header-cell
              sui-table-header-cell(
                text-align="center",
                v-for="player in selectedPlayers",
                :key="player.info.playerId") {{ player.info.gamertag }}

          sui-table-body(v-if="singleStats.length")
            sui-table-row(
              v-for="statType in statTypesPlusBest",
              :key="statType.key")
              sui-table-cell(text-align="center")
                sui-header(size="small") {{ statType.longName }}

              sui-table-cell(
                text-align="center",
                v-for="player in selectedPlayers",
                :key="player.info.playerId",
                :positive="player.stats[statType.key] === statType.best")
                  sui-icon(
                    v-if="player.stats[statType.key] === statType.best",
                    name="check")

                  | {{ player.stats[statType.key] }}

          sui-table-body(v-else)
            sui-table-row
              sui-table-cell(
                :colspan="selected.length + 1",
                text-align="center")
                sui-header(
                  size="huge",
                  icon)
                  sui-icon(name="frown outline")
                  sui-header-subheader No Data Available
</template>

<script>
export default {
  name: 'CompareTable',
  props: {
    statTypes: {
      required: true,
    },
    teams: {
      required: true,
    },
    stats: {
      required: true,
    },
  },
  data() {
    return {
      selected: [],
    };
  },
  created() {
    if (this.options.length > 1) {
      if (!this.options[1].disabled) {
        this.selected.push(this.options[1].value);
      }
      if (!this.options[this.options.length - 1].disabled) {
        this.selected.push(this.options[this.options.length - 1].value);
      }
    }
  },
  computed: {
    options() {
      return this.teams.reduce((acc, team, i) => {
        if (!team) return acc;

        const playerOptions = this.stats[i]
          .map(player => ({
            key: player.info.playerId,
            text: player.info.gamertag,
            value: player.info.playerId,
          }))
          .sort((a, b) => a.text.localeCompare(b.text, { sensitivity: 'base' }));

        return acc.concat([
          {
            key: team.teamId,
            text: team.name,
            value: team.teamId,
            image: {
              src: team.logo.main.svg,
            },
            disabled: true,
          },
          ...playerOptions,
        ]);
      }, []);
    },
    singleStats() {
      return this.stats.reduce((a, v) => a.concat(v), []);
    },
    selectedPlayers() {
      const filtered = this.singleStats.filter(player =>
        this.selected.includes(player.info.playerId),
      );
      return filtered;
    },
    statTypesPlusBest() {
      return this.statTypes.map(type => ({
        ...type,
        best: type.maximize
          ? Math.max(...this.selectedPlayers.map(player => player.stats[type.key]))
          : Math.min(...this.selectedPlayers.map(player => player.stats[type.key])),
      }));
    },
  },
};
</script>
